<template>
  <div class="slide-button-overlay" />
</template>

<style scoped lang="scss">
.slide-button-overlay {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--search-overlay);
}
</style>
